<template>
    <svg
        class="icon-share fill-current"
        viewBox="0 0 12.188 13.919"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M9.574,8.694a2.6,2.6,0,0,0-1.626.568L5.16,7.525a2.613,2.613,0,0,0,0-1.134L7.948,4.648a2.607,2.607,0,1,0-.923-1.476L4.237,4.915A2.611,2.611,0,1,0,4.237,9l2.788,1.742A2.614,2.614,0,1,0,9.574,8.694Z" /></svg>
</template>